import { USER_DATE_YEAR_MAX, USER_DATE_YEAR_MIN } from '../constants/dates'

/** Год в допустимом диапазоне пользовательских дат (2000–2100). */
export function isUserYearInRange(year: number): boolean {
  return Number.isInteger(year) && year >= USER_DATE_YEAR_MIN && year <= USER_DATE_YEAR_MAX
}

/**
 * Проверка значения <input type="date"> (YYYY-MM-DD) до отправки. Пусто → false.
 *
 * Проверяются формат и год, а НЕ календарная корректность дня: движок JS
 * разбирает «2026-02-31» как 3 марта. Из <input type="date"> такое значение не
 * приходит, так что на практике это безвредно. Год берётся из строки, а не
 * через new Date(): «62026-…» даёт валидную дату, «275760-12-31» — Invalid
 * Date, и отсечь нужно оба случая одинаково.
 */
export function isUserDateInputValid(value: string): boolean {
  const m = /^(\d{4,})-\d{2}-\d{2}$/.exec(value)
  if (!m || !isUserYearInRange(Number(m[1]))) return false
  return !Number.isNaN(new Date(value).getTime())
}

/**
 * Дедлайн для копии заявки. Старые заявки могли получить дедлайн вне
 * 2000–2100 (до 11.09.2026 создание заявки год не проверяло) — такой дедлайн в
 * копию не переносим, иначе создание копии получит отказ.
 */
export function pickCopyableDeadline(deadline: string | null | undefined): string | null {
  if (!deadline) return null
  const year = new Date(deadline).getUTCFullYear()
  return isUserYearInRange(year) ? deadline : null
}
